import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { translate } from 'react-i18next'
import AccountDetails from '../../../components/account-details/account-details'
import ChangePassword from '../../../components/account-details/change-password'
import './account-details-page.css'
import { CLEAR_PROFILE_ERROR } from '../../../actions'
import ErrorPopup from '../../../components/error-popup/error-popup'

export class AccountDetailsPage extends Component {
  constructor(props) {
    super()
  }

  profileErrorHandler = () => {
    if (this.props.profileError !== '') {
      setTimeout(() => this.props.handleAction(CLEAR_PROFILE_ERROR), 30000)
      return this.props.profileError
    }
    return false
  }

  render() {
    const { t } = this.props
    const profileError = this.profileErrorHandler()

    return (
      <div className="sign-up-page xs-flex xs-justify-center xs-items-center xs-fill-gray-lighter">

        <div className="auth-modal xs-py3 xs-px4 xs-col-12">

          <div className="xs-text-3 xs-px5 xs-text-center">{t('MANAGE_ACCOUNT')}</div>

          {profileError
            ? <ErrorPopup t={t} error={profileError} />
            : <Tabs
              selectedIndex={0}
              className="xs-fill-gray-lighter xs-text-center xs-mt3"
            >
              <TabList className="h4 bold xs-b0 xs-m0 xs-border-none">
                <Tab className="xs-border-none xs-fill-gray-lighter xs-b0">{t('ACCOUNT_DETAILS')}</Tab>
                <Tab className="xs-border-none xs-fill-gray-lighter xs-b0">{t('PASSWORD')}</Tab>
              </TabList>

              <TabPanel className="xs-fill-gray-lighter">
                <AccountDetails {...this.props} />
              </TabPanel>
              <TabPanel className="xs-fill-gray-lighter">
                <ChangePassword {...this.props} />
              </TabPanel>
            </Tabs>
          }
        </div>

      </div>
    )
  }
}

AccountDetailsPage.propTypes = {
  handleAction: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  profileError: PropTypes.string,
}

AccountDetailsPage.defaultProps = {
  handleAction: PropTypes.func.isRequired,
  profileError: '',
}

const mapStateToProps = (state) => ({
  profileError: state.profile.error,
  firstName: state.profile.firstName,
  lastName: state.profile.lastName,
  nickname: state.profile.nickname,
  email: state.profile.email,
  updated: state.profile.updated,
  photoUrl: state.profile.photoUrl,
})

const mapDispatchToProps = dispatch => ({
  handleAction: (type, payload) => dispatch({ type, payload }),
})

export default connect(mapStateToProps, mapDispatchToProps)(
  translate()(AccountDetailsPage),
)



// WEBPACK FOOTER //
// ./src/containers/pages/account-details-page/account-details-page.js